import React, { FC } from "react";

import { LinkNode, AutoLinkNode } from "@lexical/link";
import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { EditorState } from "lexical";

import { LexicalEditorErrorBoundary } from "./LexicalEditorErrorBoundary";
import { ToolbarPlugin, AutoLinkPlugin, LinkPlugin } from "./plugins";
import { LexicalEditorTheme } from "./theme/LexicalEditorTheme";

type PropsType = {
  readOnly?: boolean;
  placeholder?: string;
  className?: string;
  onChange?: (editorState: EditorState) => void;
};

export const LexicalEditor: FC<PropsType> = ({
  readOnly = false,
  placeholder = "テキストを入力...",
  className = "",
  onChange,
}) => {
  const initialConfig = {
    namespace: "LexicalEditor",
    theme: LexicalEditorTheme,
    onError: (error: Error) => {
      console.error("Lexical Error:", error);
    },
    editable: !readOnly,
    nodes: [HeadingNode, QuoteNode, LinkNode, AutoLinkNode],
  };

  return (
    <LexicalEditorErrorBoundary>
      <div className={`relative ${className}`}>
        <LexicalComposer initialConfig={initialConfig}>
          <div className="relative">
            <RichTextPlugin
              contentEditable={
                <ContentEditable className="min-h-[150px] outline-none px-2 py-2 border border-gray-300 rounded focus:border-primary-500" />
              }
              placeholder={
                <div className="absolute top-2 left-2 text-gray-400 pointer-events-none">
                  {placeholder}
                </div>
              }
              ErrorBoundary={() => (
                <div className="rounded border border-red-300 bg-red-50 p-4 text-red-700">
                  エディタでエラーが発生しました
                </div>
              )}
            />
            <HistoryPlugin />
            {onChange && <OnChangePlugin onChange={onChange} />}
            <LinkPlugin />
            <AutoLinkPlugin />
            {!readOnly && <ToolbarPlugin />}
          </div>
        </LexicalComposer>
      </div>
    </LexicalEditorErrorBoundary>
  );
};
